export const LOGOS = {
  yellow: "/images/n306w8d5_logo_yellow.png",
  original: "/images/leintnge_logo_original.png",
};

export const IMAGES = {
  hero: "/images/fjyq2r5x_magnific_premium-tavuk-restoran-ic_gJr2lxGSXO.webp",
  story: "/images/fnhfp8cp_magnific_premium-tavuk-restoran-ic_CHtlaBPEEy.webp",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Story", to: "/story" },
  { label: "Menu", to: "/menu" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "CRISPY BY DESIGN",
  "FLAVOR AS A FORMULA",
  "NOT FAST FOOD, FIELD-TESTED FOOD",
];

export const PILLARS = [
  {
    num: "01",
    title: "PRECISION",
    copy: "Every recipe is measured to the millimeter and held to absolute discipline. Nothing here is left to chance.",
  },
  {
    num: "02",
    title: "CHARACTER",
    copy: "Discipline gets you consistency. Fire gets you flavor. We bring both to every basket that leaves the kitchen.",
  },
  {
    num: "03",
    title: "THE GOLDEN FORMULA",
    copy: "Our secret sauces are a formula you can taste. Golden, and ours alone.",
  },
];

export const MENU_ITEMS = [
  {
    name: "THE ORIGINAL FORMULA",
    desc: "The recipe that started it all. Twelve hours of brine, one perfect crust.",
    price: "$12",
    img: "/images/kskgpdkr_magnific_chicken-labb-renklerini-k_gJrAOWlSXO.webp",
  },
  {
    name: "CALIBRATED HEAT",
    desc: "Our chili compound, dialed to the exact point where heat turns into flavor.",
    price: "$13",
    img: "/images/gmhl2dmt_magnific_chicken-labb-renklerini-k_swkArZbl8e.webp",
  },
  {
    name: "THE GOLD STANDARD",
    desc: "Honey-butter glaze over the signature crunch. The sweet variable.",
    price: "$14",
    img: "/images/tei1tkv1_magnific_chicken-labb-renklerini-k_1sHib6lr4r.webp",
  },
];

export const SOCIAL_STRIP = [
  "/images/piu7tl46_magnific_chicken-labb-renklerini-k_MXYH8icDCm.webp",
  "/images/3bi1pfz1_magnific_premium-tavuk-restoran-ic_gJr2s5oSXO.jpg",
  "/images/ila7ml86_magnific_premium-tavuk-restoran-ic_MXYEVWmDCm.webp",
  "/images/o0mq4ixb_magnific_premium-tavuk-restoran-ic_swkRL1Yl8e.webp",
  "/images/fnhfp8cp_magnific_premium-tavuk-restoran-ic_CHtlaBPEEy.webp",
];

export const CONTACT = {
  address: "1216 Main Ave, New Jersey",
  phone: "908 333 6363",
  social: "@chickenlabb_official",
  mapsQuery: "1216 Main Ave, New Jersey",
};

export const STORY_ORIGIN_IMAGE =
  "/images/wyd4fpzq_magnific_chicken-labb-renklerini-k_UyjYsnJwny.webp";

export const STORY_TEXTURES = {
  whyLabb:
    "/images/r4g2i8g3_magnific_chicken-labb-renklerini-k_swkArZbl8e.webp",
  cta: "/images/xq0dkqe4_magnific_chicken-labb-renklerini-k_rlqRUvHxtc.webp",
};

export const ANATOMY_CALLOUTS = [
  {
    id: "organic",
    label: "ORGANIC LIFE",
    copy: "The red comb and beak give the discipline a pulse. This is what pulls us out of a cold, clinical room and into an appetite.",
    node: { x: 500, y: 118 },
    box: { x: 690, y: 70 },
    align: "left",
  },
  {
    id: "precision",
    label: "PRECISION",
    copy: "The glass form that shapes the head and body stands for recipes built to the millimeter, with no room for improvisation.",
    node: { x: 500, y: 300 },
    box: { x: 60, y: 300 },
    align: "right",
  },
  {
    id: "golden",
    label: "THE GOLDEN FORMULA",
    copy: "The gold rising through the glass is our signature crunch and the formula behind our secret sauces. Premium, not fast food.",
    node: { x: 500, y: 470 },
    box: { x: 690, y: 500 },
    align: "left",
  },
];


const A = "/images/";
const B = "/images/";

export const MENU_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "baskets", label: "Baskets" },
  { id: "sandwiches", label: "Sandwiches" },
  { id: "tenders", label: "Tenders" },
  { id: "sauces", label: "Sauces" },
  { id: "sides", label: "Sides" },
  { id: "drinks", label: "Drinks" },
];

export const MENU_CATALOG = [
  {
    id: "original-bucket",
    name: "THE ORIGINAL BUCKET",
    desc: "Eight pieces of the recipe that started it all. Twelve-hour brine, one perfect crust.",
    price: "$18",
    category: "baskets",
    tag: "SIGNATURE",
    img: `${A}r4g2i8g3_magnific_chicken-labb-renklerini-k_swkArZbl8e.webp`,
  },
  {
    id: "family-reaction",
    name: "FAMILY FORMULA",
    desc: "A full batch for the table. Sixteen pieces, two sides, and a compound of your choice.",
    price: "$34",
    category: "baskets",
    tag: "SHARE",
    img: `${A}gmhl2dmt_magnific_chicken-labb-renklerini-k_swkArZbl8e.webp`,
  },
  {
    id: "original-formula",
    name: "THE ORIGINAL FORMULA",
    desc: "The recipe that started it all. Twelve hours of brine, one perfect crust.",
    price: "$12",
    category: "sandwiches",
    tag: "SIGNATURE",
    img: `${A}kskgpdkr_magnific_chicken-labb-renklerini-k_gJrAOWlSXO.webp`,
  },
  {
    id: "reaction-hot",
    name: "CALIBRATED HEAT",
    desc: "Our chili compound, dialed to the exact point where heat turns into flavor.",
    price: "$13",
    category: "sandwiches",
    tag: "HOT",
    img: `${A}tei1tkv1_magnific_chicken-labb-renklerini-k_1sHib6lr4r.webp`,
  },
  {
    id: "gold-standard",
    name: "THE GOLD STANDARD",
    desc: "Honey-butter glaze over the signature crunch. The sweet variable.",
    price: "$14",
    category: "sandwiches",
    tag: "SWEET",
    img: `${A}3bi1pfz1_magnific_premium-tavuk-restoran-ic_gJr2s5oSXO.jpg`,
  },
  {
    id: "lab-tenders",
    name: "ENGINEERED TENDERS",
    desc: "Five hand-breaded tenders, field-tested for the ideal crunch-to-juice ratio.",
    price: "$11",
    category: "tenders",
    img: `${A}xq0dkqe4_magnific_chicken-labb-renklerini-k_rlqRUvHxtc.webp`,
  },
  {
    id: "boneless-batch",
    name: "BONELESS BATCH",
    desc: "A pouch of bite-sized morsels. Premium crispy breaded, ready to eat.",
    price: "$15",
    category: "tenders",
    tag: "NEW",
    img: `${A}wyd4fpzq_magnific_chicken-labb-renklerini-k_UyjYsnJwny.webp`,
  },
  {
    id: "golden-formula-sauce",
    name: "GOLDEN FORMULA",
    desc: "Our secret golden compound. A formula you can taste.",
    price: "$2",
    category: "sauces",
    tag: "SIGNATURE",
    img: `${A}o0mq4ixb_magnific_premium-tavuk-restoran-ic_swkRL1Yl8e.webp`,
  },
  {
    id: "reaction-hot-sauce",
    name: "CALIBRATED HEAT SAUCE",
    desc: "The chili compound in concentrated form. Handle with discipline.",
    price: "$2",
    category: "sauces",
    tag: "HOT",
    img: `${A}ila7ml86_magnific_premium-tavuk-restoran-ic_MXYEVWmDCm.webp`,
  },
  {
    id: "smoke-compound",
    name: "SMOKE COMPOUND",
    desc: "Slow-built smoke and a whisper of char. The deep variable.",
    price: "$2",
    category: "sauces",
    img: `${A}piu7tl46_magnific_chicken-labb-renklerini-k_MXYH8icDCm.webp`,
  },
  {
    id: "lab-fries",
    name: "ENGINEERED FRIES",
    desc: "Twice-cooked, precisely salted. The control group of every order.",
    price: "$5",
    category: "sides",
    img: `${A}fjyq2r5x_magnific_premium-tavuk-restoran-ic_gJr2lxGSXO.webp`,
  },
  {
    id: "crispy-wedges",
    name: "CRISPY WEDGES",
    desc: "Skin-on, seasoned in-house, engineered for maximum surface crunch.",
    price: "$6",
    category: "sides",
    img: `${A}fnhfp8cp_magnific_premium-tavuk-restoran-ic_CHtlaBPEEy.webp`,
  },
  {
    id: "citrus-compound",
    name: "CITRUS COMPOUND",
    desc: "House citrus soda. A bright, acidic counterpoint to the crunch.",
    price: "$4",
    category: "drinks",
    img: `${B}8tzbx3ms_magnific_premium-tavuk-restoran-ic_CHtlaBPEEy.webp`,
  },
  {
    id: "cola-reaction",
    name: "COLA CONSTANT",
    desc: "Classic cola, ice-cold. The reliable constant in the formula.",
    price: "$3",
    category: "drinks",
    img: `${B}jou7fjmg_magnific_premium-tavuk-restoran-ic_gJr2lxGSXO.webp`,
  },
];
